module.exports = __webpack_public_path__ + "static/desktop/img/group-lifeman.5af8f129.png";